<template>
  <div class="plantillas-page">
    <!-- Header -->
    <div class="pl-header">
      <div>
        <span class="header-eyebrow">IA / Gmail</span>
        <h2 class="header-title">Plantillas de Email</h2>
      </div>
    </div>

    <!-- Layout -->
    <div class="pl-layout">
      <!-- Sidebar -->
      <div class="pl-sidebar">
        <div class="pl-sidebar__header">
          <h3 class="pl-sidebar__title">Plantillas</h3>
        </div>

        <div class="pl-sidebar__create">
          <input type="text" class="create-input" placeholder="Nombre plantilla..." v-model="texto" v-on:keyup.enter="addPlantilla()" />
          <button class="btn-pl btn-pl--primary btn-pl--sm" @click="addPlantilla()" :disabled="!texto">
            <i class="fa-solid fa-plus"></i>
          </button>
        </div>

        <div class="pl-sidebar__search">
          <i class="fa-solid fa-magnifying-glass search-icon"></i>
          <input type="text" class="search-input" placeholder="Buscar..." v-model="buscarPlantilla" />
        </div>

        <div class="pl-sidebar__list">
          <div
            v-for="(plantilla, index) in filterPlantillas"
            :key="index"
            :class="['pl-item', { 'pl-item--active': plantillaSelect.id === plantilla.id }]"
            @click="selectPlantilla(plantilla)"
          >
            <span class="pl-item__name">{{ plantilla.nombre }}</span>
            <button class="pl-item__delete" @click.stop="deletePlantilla(plantilla.id)" title="Eliminar">
              <i class="fa-solid fa-trash"></i>
            </button>
          </div>
          <div v-if="filterPlantillas.length === 0" class="pl-sidebar__empty">
            <span>Sin plantillas</span>
          </div>
        </div>
      </div>

      <!-- Editor -->
      <div class="pl-editor">
        <div class="pl-editor__header" v-if="plantillaSelect.id">
          <h3 class="pl-editor__title">{{ plantillaSelect.nombre }}</h3>
          <button class="btn-pl btn-pl--primary" @click="savePlantilla()">
            <i class="fa-solid fa-floppy-disk"></i> Guardar
          </button>
        </div>
        <div v-if="plantillaSelect.id" class="pl-editor__body">
          <div class="field" style="margin-bottom: 14px;">
            <label class="field__label">Explicacion para la IA</label>
            <b-form-textarea
              placeholder="Explicacion de cuando usar esta plantilla..."
              v-model="plantillaSelect.explicacion"
              rows="2"
              max-rows="6"
              class="field__input"
            />
          </div>
          <div class="editor-wrap">
            <quill-editor
              v-model="plantillaSelect.contenido"
              ref="quillEditor"
              :options="editorOption"
            />
          </div>
          <div class="pl-editor__footer">
            <button class="btn-pl btn-pl--primary" @click="savePlantilla()">
              <i class="fa-solid fa-floppy-disk"></i> Guardar
            </button>
          </div>
        </div>
        <div v-else class="pl-editor__empty">
          <i class="fa-solid fa-envelope-open-text"></i>
          <span>Selecciona una plantilla para editar</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { quillEditor } from 'vue-quill-editor'
import axios from '@axios'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: { BCardCode, quillEditor },
  data() {
    return {
      editorOption: {
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              ['link', 'imageUrl', 'video', 'formula'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
              [{ 'script': 'sub' }, { 'script': 'super' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'direction': 'rtl' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'font': [] }],
              [{ 'align': [] }],
              ['clean'],
            ],
            imageResize: true,
            handlers: {
              'imageUrl': function () {
                const url = prompt('Introduce la URL de la imagen');
                if (url) {
                  const range = this.quill.getSelection();
                  this.quill.insertEmbed(range.index, 'image', url);
                  const imageElement = this.quill.root.querySelector(`img[src="${url}"]`);
                  if (imageElement) imageElement.style.maxWidth = "500px";
                }
              }
            }
          },
        }
      },
      texto: '',
      content: '',
      plantillaSelect: { id: 0, nombre: '', contenido: '', explicacion: '' },
      plantillas: [],
      maxWidthImg: "500px",
      buscarPlantilla: ''
    }
  },
  methods: {
    addIconToVideoButton() {
      const toolbar = this.$refs.quillEditor && this.$refs.quillEditor.$el && this.$refs.quillEditor.$el.querySelector('.ql-toolbar');
      if (toolbar) {
        const video2Button = toolbar.querySelector('.ql-imageUrl');
        if (video2Button) { const icon = document.createElement('i'); icon.className = 'fa-solid fa-image'; video2Button.innerHTML = ''; video2Button.appendChild(icon); }
      }
    },
    async loadItems() {
      axios.post("/uso", { seccion: "ia-gestion-plantillas" });
      const res = await axios.get("/ia/emails/plantillas");
      this.plantillas = res.data;
    },
    selectPlantilla(plantilla) {
      this.plantillaSelect = plantilla;
      this.content = plantilla.contenido;
      setTimeout(() => {
        if (this.$refs.quillEditor && this.$refs.quillEditor.$el) {
          const images = this.$refs.quillEditor.$el.querySelectorAll('img');
          images.forEach(img => { img.style.maxWidth = this.maxWidthImg; });
        }
        this.addIconToVideoButton();
      }, 50);
    },
    addPlantilla() {
      if (!this.texto) return;
      const nueva = { id: 0, nombre: this.texto, contenido: '', explicacion: '' };
      axios.post("/ia/emails/plantillas", nueva).then(r => r.data).then(res => {
        nueva.id = res.insertId;
        this.plantillas.push(nueva);
        this.texto = '';
        this.selectPlantilla(nueva);
      });
    },
    deletePlantilla(id) {
      axios.delete("/ia/emails/plantillas/" + id).then(r => r.data).then(res => {
        this.plantillas = this.plantillas.filter(p => p.id !== id);
        if (this.plantillaSelect.id == id) this.plantillaSelect = { id: 0, nombre: '', contenido: '', explicacion: '' };
      });
    },
    savePlantilla() {
      let contenido = this.plantillaSelect.contenido;
      let tempDiv = document.createElement('div');
      tempDiv.innerHTML = contenido;
      tempDiv.querySelectorAll('img').forEach(img => { img.style.maxWidth = this.maxWidthImg; });
      contenido = tempDiv.innerHTML;
      axios.put("/ia/emails/plantillas", { id: this.plantillaSelect.id, contenido, explicacion: this.plantillaSelect.explicacion }).then(r => r.data).then(res => {
        this.$toast({ component: ToastificationContent, props: { title: "Plantilla guardada", icon: "EditIcon", variant: "success" } });
      }).catch(err => {
        this.$toast({ component: ToastificationContent, props: { title: "Error al guardar", icon: "EditIcon", variant: "danger" } });
      });
    },
  },
  mounted() { this.loadItems(); setTimeout(() => { this.addIconToVideoButton(); }, 500); },
  computed: {
    filterPlantillas() {
      const q = this.buscarPlantilla.toLowerCase();
      return this.plantillas.filter(pl => pl.nombre.toLowerCase().includes(q) || pl.contenido.toLowerCase().includes(q));
    },
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
</style>

<style lang="scss" scoped>
$primary: #3B82F6;
$primary-dark: #2563EB;
$success: #10B981;
$danger: #EF4444;
$border: #E2E8F0;
$text: #1E293B;
$text-muted: #64748B;
$bg: #F8FAFC;
$card-bg: #FFFFFF;
$radius: 12px;
$radius-sm: 8px;
$shadow: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);

.plantillas-page { max-width: 1400px; margin: 0 auto; padding: 0 8px; }

.pl-header { margin-bottom: 20px; }
.header-eyebrow { display: block; font-family: 'JetBrains Mono', monospace; font-size: 11px; font-weight: 600; letter-spacing: 1.5px; text-transform: uppercase; color: $primary; margin-bottom: 2px; }
.header-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 24px; font-weight: 700; color: $text; margin: 0; }

// Layout
.pl-layout { display: grid; grid-template-columns: 300px 1fr; gap: 16px; align-items: start; }

// Sidebar
.pl-sidebar {
  background: $card-bg; border: 1px solid $border; border-radius: $radius; box-shadow: $shadow; overflow: hidden;
  &__header { padding: 16px 18px 0; }
  &__title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 15px; font-weight: 700; color: $text; margin: 0 0 12px; }
  &__create { display: flex; gap: 6px; padding: 0 18px; margin-bottom: 10px; }
  &__search { position: relative; padding: 0 18px; margin-bottom: 8px; }
  &__list { max-height: calc(100vh - 340px); overflow-y: auto; padding: 0 8px 8px; }
  &__empty { padding: 20px; text-align: center; font-family: 'JetBrains Mono', monospace; font-size: 12px; color: $text-muted; }
}

.create-input {
  flex: 1; padding: 6px 10px; border: 1px solid $border; border-radius: $radius-sm;
  font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; color: $text;
  &::placeholder { color: #CBD5E1; } &:focus { outline: none; border-color: $primary; }
}

.search-icon { position: absolute; left: 28px; top: 50%; transform: translateY(-50%); color: $text-muted; font-size: 11px; }
.search-input {
  width: 100%; padding: 6px 10px 6px 30px; border: 1px solid $border; border-radius: $radius-sm;
  font-family: 'Plus Jakarta Sans', sans-serif; font-size: 12px; color: $text; background: transparent;
  &::placeholder { color: #CBD5E1; } &:focus { outline: none; border-color: $primary; }
}

.pl-item {
  display: flex; align-items: center; justify-content: space-between; padding: 8px 12px; border-radius: $radius-sm;
  cursor: pointer; transition: all 0.15s; margin-bottom: 2px;
  &:hover { background: $bg; }
  &--active { background: rgba($primary, 0.06); }
  &__name { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; font-weight: 500; color: $text; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex: 1; }
  &__delete { width: 26px; height: 26px; border-radius: 6px; border: none; background: transparent; color: $text-muted; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 11px; opacity: 0; transition: all 0.15s; flex-shrink: 0;
    &:hover { background: rgba($danger, 0.1); color: $danger; }
  }
  &:hover &__delete { opacity: 1; }
  &--active &__name { color: $primary; font-weight: 600; }
}

// Buttons
.btn-pl {
  display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; border-radius: $radius-sm; border: none;
  font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; font-weight: 600; cursor: pointer; transition: all 0.15s;
  &--primary { background: $primary; color: white; &:hover { background: $primary-dark; } &:disabled { opacity: 0.4; cursor: not-allowed; } }
  &--sm { padding: 6px 12px; font-size: 12px; }
}

// Editor
.pl-editor {
  background: $card-bg; border: 1px solid $border; border-radius: $radius; box-shadow: $shadow; overflow: hidden;
  &__header { display: flex; justify-content: space-between; align-items: center; padding: 16px 22px; border-bottom: 1px solid $border; }
  &__title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 16px; font-weight: 700; color: $text; margin: 0; }
  &__body { padding: 20px 22px; }
  &__footer { padding: 0 0 4px; display: flex; justify-content: flex-end; margin-top: 14px; }
  &__empty { display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 80px 0; i { font-size: 32px; color: #CBD5E1; } span { font-family: 'JetBrains Mono', monospace; font-size: 13px; color: $text-muted; } }
}

.field {
  display: flex; flex-direction: column; gap: 5px;
  &__label { font-family: 'JetBrains Mono', monospace; font-size: 10px; font-weight: 600; letter-spacing: 0.5px; text-transform: uppercase; color: $text-muted; margin: 0; }
  &__input { border-radius: 8px !important; border: 1px solid $border !important; font-size: 13px !important; &:focus { border-color: $primary !important; box-shadow: 0 0 0 3px rgba($primary, 0.1) !important; } }
}

.editor-wrap {
  border: 1px solid $border; border-radius: $radius-sm; overflow: hidden;
}

// Responsive
@media (max-width: 992px) { .pl-layout { grid-template-columns: 1fr; } .pl-sidebar__list { max-height: 300px; } }
</style>

<style lang="scss">
// Dark mode
.dark-layout {
  .plantillas-page {
    .header-title { color: #E2E8F0; }
    .pl-sidebar { background: #1E293B; border-color: #334155; }
    .pl-sidebar__title { color: #E2E8F0; }
    .create-input { border-color: #334155; color: #E2E8F0; background: #0F172A; }
    .search-input { border-color: #334155; color: #E2E8F0; }
    .pl-item { &:hover { background: rgba(255,255,255,0.03); } &--active { background: rgba(#3B82F6, 0.08); } }
    .pl-item__name { color: #E2E8F0; }
    .pl-item__delete { color: #94A3B8; }

    .pl-editor { background: #1E293B; border-color: #334155; }
    .pl-editor__header { border-color: #334155; }
    .pl-editor__title { color: #E2E8F0; }
    .field__label { color: #94A3B8; }
    .field__input { background: #0F172A !important; border-color: #334155 !important; color: #E2E8F0 !important; }
    .editor-wrap { border-color: #334155; }
  }
}
</style>
